import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-three-section',
  templateUrl: './explore-three-section.component.html',
  styleUrls: ['./explore-three-section.component.scss']
})
export class ExploreThreeSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
